import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import BubbleCard from '@/components/BubbleCard';
import { Plus, Sparkle, Lightning } from '@phosphor-icons/react';

const Bubbles = () => {
  const [mine, setMine] = useState([]);
  const [trending, setTrending] = useState([]);

  useEffect(() => {
    api.get('/bubbles/mine').then(({ data }) => setMine(data.bubbles));
    api.get('/bubbles?sort=velocity&limit=12').then(({ data }) => setTrending(data.bubbles));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-10 pb-24">
      <section>
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter">Your Bubbles</h1>
            <p className="text-white/60 mt-1">Each one is alive. Pass them forward to grow energy.</p>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/express" data-testid="bubbles-express-cta"
                  className="px-4 py-3 rounded-full glass-hi hover:bg-white/10 text-xs uppercase tracking-widest font-bold flex items-center gap-1.5">
              <Lightning size={14} weight="fill" className="text-bx-volt" /> Express · 30s
            </Link>
            <Link to="/breathe" data-testid="bubbles-blow-cta" className="btn-volt px-5 py-3 rounded-full text-sm flex items-center gap-1.5">
              <Plus size={16} weight="bold" /> Blow
            </Link>
          </div>
        </div>

        {mine.length === 0 ? (
          <div className="glass rounded-2xl p-10 text-center">
            <Sparkle size={36} className="text-bx-cyan mx-auto" weight="duotone" />
            <h3 className="font-display text-xl font-bold mt-3">No bubbles yet</h3>
            <p className="text-white/60 mt-1">Blow your first to join the movement.</p>
            <Link to="/breathe" data-testid="bubbles-empty-blow" className="btn-primary px-6 py-3 rounded-full text-sm inline-flex items-center gap-1.5 mt-5">
              Blow your first <Sparkle size={14} weight="fill" />
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
            {mine.map((b) => (
              <Link to={`/bubble/${b.id}`} key={b.id} className="glass rounded-2xl p-5 hover:bg-white/5 transition" data-testid={`my-bubble-${b.id}`}>
                <BubbleCard bubble={b} size="sm" />
                <div className="mt-3 flex items-center justify-between text-[11px] uppercase tracking-widest">
                  <span className="text-bx-cyan">⚡ {b.energy}</span>
                  <span className="text-bx-volt">v{b.velocity}</span>
                  <span className="text-white/60">stg {b.evolution_stage}</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>

      <section className="mt-16">
        <h2 className="font-display text-3xl font-black tracking-tighter">Trending right now</h2>
        <p className="text-white/55 mt-1">Highest velocity bubbles in the last cycles.</p>
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {trending.map((b) => (
            <Link to={`/bubble/${b.id}`} key={b.id} className="glass rounded-2xl p-4 hover:bg-white/5 transition" data-testid={`trend-bubble-${b.id}`}>
              <BubbleCard bubble={b} size="sm" />
              <div className="mt-2 text-center text-[10px] uppercase tracking-widest text-white/65">
                v{b.velocity} · ⚡{b.energy}
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Bubbles;
